import { Module } from "types/generated";

import { generateUniqueSharedAccounts } from "../SharingNew/utils";

export const getDefaultValues = (module: Module) => {
  const uniqueSharedAccounts = generateUniqueSharedAccounts(module.moduleShares);

  const sharedAccounts =
    uniqueSharedAccounts.length === 0
      ? [{ value: "" }]
      : uniqueSharedAccounts.map((share) => ({ value: share }));

  const sharedSpaces = module?.moduleShares.filter((share) => share.to.space);
  const mappedSharedSpaces =
    sharedSpaces.length === 0
      ? [{ value: "" }]
      : sharedSpaces.map((space) => ({ value: space.to.space?.id }));

  return {
    sharedAccounts,
    sharedSpaces: mappedSharedSpaces,
  };
};
